import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatLegacyButtonModule } from '@angular/material/legacy-button';
import { MatIconModule } from '@angular/material/icon';
import { ZefDialogModule } from '@zerops/zef/dialog';
import { AuthTokenStorageService } from '@zerops/zef/auth';

@Component({
  selector: 'z-cross-tab-session-dialog',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ ZefDialogModule, MatLegacyButtonModule, MatIconModule ],
  template: `
    <zef-dialog
      [open]="tokenStorage.sessionInvalidated()"
      [options]="{ maxWidth: '450px', width: '100%', disableClose: true }">
      <div class="__content">
        @switch (tokenStorage.sessionInvalidReason()) {
          @case ('logout') {
            <h3 class="__title">Session ended</h3>
            <p class="__cross-tab-desc">You were logged out in another browser tab.</p>
          }
          @case ('clientChanged') {
            <h3 class="__title">Organization changed</h3>
            <p class="__cross-tab-desc">A different organization was selected in another browser tab.</p>
          }
          @default {
            <h3 class="__title">Session changed</h3>
            <p class="__cross-tab-desc">A different account was signed in from another browser tab.</p>
          }
        }
        <button
          mat-flat-button
          color="accent"
          (click)="onReload()"
          class="c-button--full">
          Continue
          <mat-icon>navigate_next</mat-icon>
        </button>
      </div>
    </zef-dialog>
  `,
  styles: [`
    .__content { padding: 24px; text-align: center; }
    .__title { margin: 0 0 8px; }
    .__cross-tab-desc { margin: 0 0 24px; color: rgba(0,0,0,0.6); }
    /* zef-dialog portals the content — :host-context never matches here */
    ::ng-deep html.zef-dark-theme mat-dialog-container .__cross-tab-desc { color: #9faea9; }
  `]
})
export class CrossTabSessionDialogFeature {
  tokenStorage = inject(AuthTokenStorageService);

  onReload() {
    // Always reload — the boot flow (onCheckToken$) is the single source of truth:
    // no token → /login, userId mismatch → /dashboard/projects,
    // clientUserId mismatch → /dashboard/projects, everything matches → stay.
    window.location.reload();
  }
}
